export default "__VITE_ASSET__87f52c32__"